import { Component } from '@angular/core';
import { CustomService } from '../shared/services/custom.service';
import Swal from 'sweetalert2';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment'
import { AuthService } from '../auth.service';
import { Subject, take } from 'rxjs';

@Component({
  selector: 'app-report-discrepancy',
  templateUrl: './report-discrepancy.component.html',
  styleUrls: ['./report-discrepancy.component.css']
})
export class ReportDiscrepancyComponent {

  //variable declarion
  categoryData: any;
  categoryList: any;
  pubNumber = '';
  revNumber = '';
  ataNumber = '';
  revDate = '';
  other = '';
  isOther = true;
  pageNumber = '';
  paragraph = '';
  tableNumber = '';
  figNumber = '';
  comments = '';
  fieldObj: any;
  //auto poplation varibale declaration
  pubId = '';
  pubType = '';
  org = '';
  pubStatus = '';
  lic = '';
  vol = '';
  expCode = '';
  userId = '';
  alertWarn = '';
  //length fields
  pubnumLen: any;
  ataLen: any;
  revLen: any;
  pageNumLen: any;
  paraLen: any;
  tableLen: any;
  figureLen: any;
  commentsLen: any;
  otherLen: any;
  fieldsLen: any;
  isLoading: boolean = false;

  ifAlertMsg = false;
  alertMsg = '';
  techFAQ: any;
  privacy: any;
  userCompanyName: any;
  userName: any;
  email: any;
  userUuid: any;
  pending: any = [];
  disableSubmit = true;
  clickedSub = new Subject<boolean>();
  pageNumbError = false;
  paraNumbError = false;
  figuNumbError = false;
  tablNumbError = false;
  commentsError = false;
  othersError = false;
  valErrorMsg = '';
  constructor(
    private CustomService: CustomService,
    private cookieService: CookieService,
    private authService: AuthService) {
  }

  ngOnInit() {
    this.discrepancySavePopup();
  }

  clicked$ = this.clickedSub.pipe(take(1)).subscribe((click) => {
    this.Submit();
  });

  getDataFromAero() {
    //let cookieValue = "vault:v1:Wo97/nY2gIurnvwKKAydvYayduiG9xZJ04x+gA0OvLUS8QXORO8d2GIHIcmR9P30lpenRm4MfBE2dbIvElKHPvgibOjLVI2sS3cnfYmxE9Q62ZMC/sW7hLGcKMxMKtT92ojdeRn6D0NYMSbCrqTaGcfrrrVcaAk2lIShIt0UzqePYyS/SThoMqpFGDfUiQy6SEB/URk6N5dlo9UTBKWqghw2uf036Kb2B1ae5+JinlJGxFt7u07w+F1znOMZO+kiOl7Q2is9MbkvJUU/gEmexK2zF78vUK8SBKNlToCFAxMb4H+oVr8au45WiPi2pIm9NvCqf+BNAQLEVM4+xF5y1pYdGYNvLM2MIVue0/dFpquHFDmNQgpqkJ+uQIuC5o4vW4el9Ci1ZyMeKygva9a6StrkN5KmN0CPSTncJ8W4ZnQWYAlsXBebqDgBwuVpHOS5GgclXtJ2HoBOKQ==";
    let cookieValue = this.cookieService.get('publication');
    //autopopulation fields
    if (cookieValue) {
      const requestBody = { ciphertext: cookieValue }
      this.isLoading = true;
      this.CustomService.decryptData(requestBody).subscribe((res: any) => {
        if (res && res.statusCode === 200) {
          let cookieData = res.data;
          this.pubNumber = cookieData.pub_number;
          this.revNumber = cookieData.rev_no;
          this.ataNumber = cookieData.ata;
          this.revDate = cookieData.rev_date;
          this.pubId = cookieData.pub_id;
          this.pubType = cookieData.pub_type;
          this.org = cookieData.org;
          this.pubStatus = cookieData.pub_status;
          this.lic = cookieData.lic;
          this.vol = cookieData.vol;
          this.expCode = cookieData.export_code;
          this.userName = cookieData.userName;
          this.userCompanyName = cookieData.userCompanyName;
          this.email = cookieData.email;
          this.userUuid = cookieData.userUuid;
          this.isLoading = false;
        }
      });
    }
  }

  onKeyPressEvent(event: any) {
    if (event.keyCode === 33 || event.keyCode === 64 || event.keyCode === 94 ||
      event.keyCode === 61 || event.keyCode === 124 ||
      event.keyCode === 60 || event.keyCode === 62) {
      event.preventDefault();
      Swal.fire('Warning!', 'Special characters | @ ! ^ = < > are not allowed', 'warning');
      // Swal.fire('Warning!', 'Only special characters () # $ % & * + : " \' ` ~ . - {} [] ; / , _ ? are allowed', 'warning');
    }
  }

  validationFields(): boolean {
    if (this.categoryList !== 'select') {
      if (this.categoryList && this.categoryList.id === 27) {
        this.disableSubmit = false;
        return this.pubNumber && this.pageNumber && this.comments && this.categoryList && this.other;
      } else {
        this.disableSubmit = false;
        return this.pubNumber && this.pageNumber && this.comments && this.categoryList && this.categoryList !== 'select';
      }
    } else {
      return false;
    }
  }

  onCategoryType(): void {
    this.CustomService.getAllCategory().subscribe((res: any) => {
      if (res && res.statusCode === 200) {
        this.categoryData = res.data;
      }
    });
  }

  discrepancySavePopup() {
    //clear fields
    this.fieldAssigned();
    //dropdown
    this.onCategoryType();
    //check field length
    this.checkAllFieldLength();
    //get cookie value from Aero space team
    this.getDataFromAero();
  }

  onCategorySelected(val: any) {
    if (val && val.id === 27) {
      this.isOther = false;
    } else {
      this.isOther = true;
      this.other = '';
      this.othersError = false;
    }
  }

  checkAllFieldLength() {
    this.CustomService.checkFieldLength().subscribe((res: any) => {
      if (res && res.statusCode === 200) {
        this.fieldsLen = res.data;
        this.fieldData(this.fieldsLen);
      }
    });
  }

  fieldData(fieldLen: any) {
    let f4 = fieldLen.filter((item: any) => item.field === 'PAGENO');
    this.pageNumLen = f4[0].maxlength;
    let f5 = fieldLen.filter((item: any) => item.field === 'PARANO');
    this.paraLen = f5[0].maxlength;
    let f6 = fieldLen.filter((item: any) => item.field === 'TABLENO');
    this.tableLen = f6[0].maxlength;
    let f7 = fieldLen.filter((item: any) => item.field === 'FIGURENO');
    this.figureLen = f7[0].maxlength;
    let f8 = fieldLen.filter((item: any) => item.field === 'COMMENTS');
    this.commentsLen = f8[0].maxlength;
    let f9 = fieldLen.filter((item: any) => item.field === 'DESCRIPTION');
    this.otherLen = f9[0].maxlength;
  }

  clickSubmitEvent() {
    // let splAvl = /[\]\[\<\>\\\?\@\!\(\)/\{\}\|\=\_\;\,\^]/;
    let splAvl = /[\|\@\!\^\=\<\>]/;
    this.pageNumbError = splAvl.test(this.pageNumber);
    this.paraNumbError = splAvl.test(this.paragraph);
    this.figuNumbError = splAvl.test(this.figNumber);
    this.tablNumbError = splAvl.test(this.tableNumber);
    this.commentsError = splAvl.test(this.comments);
    if (this.other) {
      this.othersError = splAvl.test(this.other);
    }
    if (!this.pageNumbError && !this.paraNumbError && !this.figuNumbError && !this.tablNumbError && !this.commentsError && !this.othersError) {
      this.clickedSub.next(true);
    } else {
      this.valErrorMsg = 'Special characters | @ ! ^ = < > are not allowed';
      setTimeout(() => {
        this.valErrorMsg = '';
      }, 3000);
    }
  }

  Submit() {
    this.disableSubmit = true;
    let authUserId = localStorage.getItem('authUserId');
    let formData: any = new FormData();
    //AeroSpace fields
    formData.append('PUBLICATION_ID', this.pubId);
    formData.append('PUBNUMBER', this.pubNumber);
    formData.append('ATANUMBER', this.ataNumber);
    formData.append('ORIG_REV', this.revNumber);
    formData.append('REVDATESTRING', this.revDate);
    formData.append('PUBLICATIONTYPE', this.pubType);
    formData.append('ORGANIZATION', this.org);
    formData.append('PUBSTATUS', this.pubStatus);
    formData.append('LICENSE', this.lic);
    formData.append('VOLUME', this.vol);
    formData.append('EXPORTCODE', this.expCode);
    formData.append('USERID', authUserId);
    formData.append('OTHER', this.other);
    formData.append('ORIG_CAT_CODE', this.categoryList.id);
    formData.append('PAGENO', this.pageNumber);
    formData.append('PARANO', this.paragraph);
    formData.append('TABLENO', this.tableNumber);
    formData.append('FIGURENO', this.figNumber);
    formData.append('COMMENTS', this.comments);
    formData.append('USERNAME', this.userName);
    formData.append('USERCOMPANYNAME', this.userCompanyName);
    formData.append('USERUUID', this.userUuid);
    formData.append('EMAIL', this.email);
    this.CustomService.saveDiscrepancyReport(formData).pipe(take(1)).subscribe(
      (res: any) => {
        if (res && res.statusCode === 200 && res.data) {
          this.ifAlertMsg = true;
          this.alertMsg = "Discrepancy Reported ! We will respond back to you with in 24 hours.";
          this.cookieService.delete('publication');
          this.disableSubmit = true;
          setTimeout(() => {
            this.cancelPopup();
          }, 1000);
        }
        if (res?.message === 'Invalid user') {
          this.alertWarn = "Something went wrong due to Invalid User!";
        }
        setTimeout(() => {
          this.alertWarn = '';
          this.alertMsg = '';
        }, 2000);
      }, error => {
        this.disableSubmit = false;
        if (error?.error?.message === 'Invalid user') {
          this.alertWarn = "Something went wrong due to Invalid User!";
        }
        setTimeout(() => {
          this.alertWarn = '';
          this.alertMsg = '';
        }, 2000);
      });
  }

  cancelPopup() {
    this.ifAlertMsg = false;
    this.fieldAssigned();
    this.cookieService.delete('publication');
    window.location.replace(environment.redirectAeroHomePage);
  }

  fieldAssigned() {
    this.categoryList = 'select';
    this.pubNumber = '';
    this.revNumber = '';
    this.ataNumber = '';
    this.revDate = '';
    this.isOther = true;
    this.other = '';
    this.pageNumber = '';
    this.paragraph = '';
    this.tableNumber = '';
    this.figNumber = '';
    this.comments = '';
    //auto poplation varibale declaration
    this.pubId = '';
    this.pubType = '';
    this.org = '';
    this.pubStatus = '';
    this.lic = '';
    this.vol = '';
    this.expCode = '';
    this.userId = '';
  }

  setPrivacy() {
    this.privacy = environment.privPolicy;
    window.open(
      this.privacy,
      '_blank'
    );
  }

  setFAQ() {
    this.techFAQ = environment.technicalFAQ;
    window.open(
      this.techFAQ,
      '_blank'
    );
  }

  logout() {
    this.authService.logout();
  }

}
